import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface OtherAssetsRommsProps {
  onBack: () => void;
}

export default function OtherAssetsRomms({ onBack }: OtherAssetsRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Other Assets" />;
}


